export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 157;
export const SIDEBAR_WIDTH = 250;
